import { render, staticRenderFns } from "./ProjetAuthorization.vue?vue&type=template&id=9d1ff74e&"
import script from "./ProjetAuthorization.vue?vue&type=script&lang=js&"
export * from "./ProjetAuthorization.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports